/* Functions here is to handle everything about
 * localStorage, sessionStorage or cookie
 */
import { SESSION, SHARED } from "@/constants";

export function getUserName() {
  return localStorage.getItem(SESSION.USER_NAME);
}

export function getUserEmail() {
  return localStorage.getItem(SESSION.USER_EMAIL) || "";
}

export function getUserToken() {
  return localStorage.getItem(SESSION.JWT_TOKEN);
}

export function getUserType() {
  return localStorage.getItem(SESSION.USER_TYPE);
}

export function getUserExpiredTime() {
  return localStorage.getItem(SESSION.TOKEN_EXPIRY_TIME);
}

export function getUserRefreshExpiredTime() {
  return localStorage.getItem(SESSION.REFRESH_TOKEN_EXPIRY_TIME);
}

export function getPermissions() {
  return localStorage.getItem(SESSION.PERMISSIONS);
}

export function isSuperadminUser() {
  try {
    const user = JSON.parse(localStorage.getItem(SESSION.USER) || "null")?.user;
    return [true, 1, "1"].includes(user?.isSuperadmin ?? user?.is_superadmin);
  } catch (error) {
    return false;
  }
}

function isPermissionKey(key) {
  return (
    typeof key === "string" &&
    /^[a-z][a-z0-9_]*$/.test(key) &&
    !["constructor", "prototype"].includes(key)
  );
}

// Read permission levels from the cached login response, not the access token.
export function getUserPermissions(permissions,superadmin = isSuperadminUser()) {
  const unrestricted = [true, 1, "1"].includes(superadmin);
  let levels = {};
  try {
    const source =
      permissions === undefined
        ? JSON.parse(getPermissions() || "{}")
        : permissions;
    if (source && typeof source === "object" && !Array.isArray(source))
      levels = Object.fromEntries(
        Object.entries(source)
          .filter(
            ([key, level]) =>
              isPermissionKey(key) &&
              ((typeof level === "number" && [0, 1, 2].includes(level)) ||
                (typeof level === "string" && /^[012]$/.test(level))),
          )
          .map(([key, level]) => [key, unrestricted ? 2 : Number(level)]),
      );
  } catch (error) {
    levels = {};
  }
  if (!unrestricted) return levels;
  // Resolve all permission keys as Write, including keys omitted by the API.
  // Keep the stored response unchanged so removing superadmin restores its levels.
  return new Proxy(levels, {
    get(target, key, receiver) {
      return isPermissionKey(key) ? 2 : Reflect.get(target, key, receiver);
    },
  });
}

export function getPermissionLevel(key) {
  if (!isPermissionKey(key)) return 0;
  if (isSuperadminUser()) return 2;
  const permissions = getUserPermissions();
  return Object.prototype.hasOwnProperty.call(permissions, key)
    ? permissions[key]
    : 0;
}

export function clearAllClientStorage() {
  localStorage.clear();
  sessionStorage.clear();
}

export function isTokenExpired() {
  let result = false;
  let tokenExpiry = localStorage.getItem(SESSION.TOKEN_EXPIRY_TIME);

  if (tokenExpiry && !isNaN(Date.parse(tokenExpiry))) {
    let currentTime = new Date();
    tokenExpiry = new Date(tokenExpiry);

    // Subtract 3 minutes (in milliseconds) from the token expiry time
    tokenExpiry.setMinutes(tokenExpiry.getMinutes() - 3);
    result = currentTime >= tokenExpiry;
  } else {
    result = true;
  }

  return result;
}

export function isRefreshTokenExpired() {
  let result = false;
  let tokenExpiry = localStorage.getItem(SESSION.REFRESH_TOKEN_EXPIRY_TIME);

  if (tokenExpiry && !isNaN(Date.parse(tokenExpiry))) {
    let currentTime = new Date();
    tokenExpiry = new Date(tokenExpiry);

    // Subtract 3 minutes (in milliseconds) from the token expiry time
    tokenExpiry.setMinutes(tokenExpiry.getMinutes() - 3);
    result = currentTime >= tokenExpiry;
  } else {
    result = true;
  }

  return result;
}

export function calculateTime(seconds) {
  if (seconds && isNaN(seconds) && !isNaN(Date.parse(seconds)))
    return new Date(seconds);

  var currentDate = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Asia/Kuala_Lumpur" }),
  );
  var expiredSeconds = parseInt(seconds);

  // Get the current time in seconds
  var currentDateSeconds = currentDate.getSeconds();

  // Add expired seconds to the current time
  currentDate.setSeconds(currentDateSeconds + expiredSeconds);

  return currentDate;
}

export function hasAuthToken() {
  let result = false;

  if (getUserToken()) {
    result = true;
  }

  return result;
}

export function isActiveUser() {
  let result = false;
  let lastActivityTime = localStorage.getItem(SESSION.LAST_ACTIVITY_TIME);

  if (lastActivityTime) {
    result =
      new Date().getTime() - parseInt(lastActivityTime) < SHARED.USER_IDLE_TIME;
  }

  return result;
}

/* START Search Criteria */
export function storeSearch(name, value) {
  let str = typeof value === "string" ? value : JSON.stringify(value);
  sessionStorage.setItem(name, str);
}

export function retrieveSearch(name) {
  let f = sessionStorage.getItem(name);
  let result = f != undefined && f != null && f != "" ? JSON.parse(f) : "";

  return result;
}

//need this when page refresh
export function clearSearch(name) {
  sessionStorage.removeItem(name);
}

export function hasSearchCriteria(name) {
  let f = sessionStorage.getItem(name);
  return f != undefined && f != null && f != "";
}
